import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
export interface IConsentStateSlice {
  consentFilter: number[];
  selectedResidentConsent?: IConsent | null;
}

const name = "consent";

export const initialState: IConsentStateSlice = {
  consentFilter: [0, 1, 2, 3],
  selectedResidentConsent: null,
};

export const consentSlice = createSlice({
  name,
  initialState,
  reducers: {
    setConsentFilter(
      state,
      action: PayloadAction<IConsentStateSlice["consentFilter"]>
    ) {
      state.consentFilter = action.payload;
    },
    setSelectedResidentConsent(
      state,
      action: PayloadAction<IConsentStateSlice["selectedResidentConsent"]>
    ) {
      state.selectedResidentConsent = action.payload;
    },
  },
});

export const { setConsentFilter, setSelectedResidentConsent } =
  consentSlice.actions;

const persistedReducer = persistReducer(
  {
    key: name,
    storage: storage,
    whitelist: ["consentFilter", "selectedResidentConsent"],
  },
  consentSlice.reducer
);

export default persistedReducer;
